import React, { useEffect, useRef, useState } from 'react';
import * as actionCreators from '../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, FormControl, InputGroup, Alert, Modal, Fade, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import SpinnerLoading from '../Components/SpinnerLoading';
import ConfirmBuy from '../Components/ConfirmBuy';
import axios from 'axios';
import './styles.css'
import photoLogin from '../assets/photoLogin.png'

const url = process.env.REACT_APP_CLA_URL;
const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

function Login({ user, logIn, codpmpol, tkn }) {
    const [state, setState] = useState({ user: /*localStorage.getItem('email') ? JSON.parse(localStorage.getItem('email')) :*/ '', password: '', userForgotten: '' });
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const loginInput = useRef(null);
    const passwordInput = useRef(null);
    const params = new URLSearchParams();
    params.set('opcpm', "SendMail");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleKeyPress = (e) => e.charCode === 13 && handleSubmit();
    const validateEmail = (email) => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email));

    const handleChange = (e) => {
        if (e.target.name === "password")
            if (e.target.value.length >= 4)
                setDisabled(false);
            else
                setDisabled(true);
        setError(false);
        setState((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        });
    };

    const handleSubmit = () => {
        const dir = window.location.href
        const test = state.user.includes("_test") || process.env.NODE_ENV === 'development';
        setLoading(false);
        setError(false);
        if (validateEmail(state.user) && state.password.length > 3) {
            setLoading(true);
            logIn({ ...state, user: state.user, test, token: tkn });
        } else {
            setError(true);
        }
    };

    const sendMail = () => {
        handleClose();
        params.set('email', state.userForgotten);
        axios.post(url, params, options)
    };

    useEffect(() => {
        setLoading(false);
        setError(false);
        if (user.email === 'error' || user.error) {
            localStorage.removeItem('hash');
            localStorage.removeItem('date');
            setError(true);
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        if (user.email === '') {
            loginInput.current.focus();
        } else {
            passwordInput.current.focus();
        }
        if (tkn) setLoading(true);
    }, [tkn]);

    return (
        <Fade appear in>
					<div className={'login'}>
						<div className="container mx-auto mt-5 p-0 custom-border-login res-section">
							{codpmpol ?
								(
									<ConfirmBuy
										codpmpol={codpmpol}
									/>
								) : (
									<section className='d-flex flex-column-reverse m-0 position-relative custom-heigth-login res-login'>
										<div className=' my-auto h-50 res-width'>
											<div className='position-absolute px-4 py-3 div-input res-input'>
													<h1 className='m-0 mb-4 fs-1 text-center font-platform res-text'>Bienvenido</h1>
													{loading ? (
														<SpinnerLoading />
													) : (
															<>
																<InputGroup className="my-3 height-input-login">
																	<FormControl
																		placeholder="E-mail"
																		value={state.user}
																		onChange={handleChange}
																		name="user"
																		aria-describedby="Email"
																		onKeyPress={handleKeyPress}
																		ref={loginInput}
																		/>
																</InputGroup>
																<InputGroup className="my-3 height-input-login">
																	<FormControl
																		placeholder="Contraseña"
																		value={state.password}
																		onChange={handleChange}
																		name="password"
																		type='password'
																		aria-describedby="Password"
																		onKeyPress={handleKeyPress}
																		ref={passwordInput}
																		/>
																</InputGroup>
																{(error || user.error) &&
																	<Alert className='mt-2' variant={'danger'}>
																		{user.msgError !== '' ? (
                                                                            <p className='m-0'>{user.msgError}</p>
																		)	:	(
                                                                            <p className='m-0'>El usuario o la contraseña son incorrectos</p>
                                                                        )}
																	</Alert>
																}
																<p className='text-end font-platform fs-6 font-forget' onClick={handleShow}>¿Olvidaste la contraseña?</p>
														</>
													)}
													<Button className={`${disabled ? 'btn-disabled' : ''} height-input-login`} onClick={handleSubmit} disabled={disabled}>Ingresar</Button>
											<Alert className='max-shadow m-0 mt-3 res-login-active' variant={'primary'}>
												<FontAwesomeIcon className='me-2' icon={faInfoCircle} />
												Si todavía no tienes los datos de su usuario solicitelo al administrador.
											</Alert>
											</div>
										</div>
										<div className='position-relative h-75 custom-img-login res-width'>
											<Image className='custom-img' src={photoLogin}></Image>	
                                            <p className='m-0 fs-4 mt-4 ms-4 position-absolute font-platform color-font-lightblue is-hidden'><span className='fw-semibold'>PLATFORM</span>EVO</p>
										</div>  
									</section>
								)}
						</div>
							{!codpmpol && (<>
									<Alert className='max-shadow mb-4 mx-auto login-active' variant={'primary'}>
											<FontAwesomeIcon icon={faInfoCircle} />
											Si todavía no tienes los datos de su usuario solicitelo al administrador.
									</Alert>
									
									<Modal show={show} onHide={handleClose} size="lg">
											<Modal.Header closeButton>
													<Modal.Title>Olvidé mi contraseña</Modal.Title>
											</Modal.Header>
											<Modal.Body>
													<p>Ingrese e-mail para enviar enlace para que pueda restablecer su contraseña.</p>
													<p>Si el usuario existe con ese email, le llegará un correo para reiniciar la clave.</p>
													<FormControl
															placeholder="E-mail"
															value={state.userForgotten}
															onChange={handleChange}
															name="userForgotten"
															aria-describedby="Email"
													/>
											</Modal.Body>
											<Modal.Footer>
													<Button onClick={sendMail} className="main-btn">
															Restablecer contraseña
													</Button>
											</Modal.Footer>
									</Modal>
							</>)}
                            <footer className="footer-mn">
                                <p className='font-copy m-0'>{" "}Platform Evo {process.env.REACT_APP_VERSION} © {new Date().getFullYear()} Todos los derechos reservados.</p>
                            </footer>
					</div>
        </Fade>
    )
}

function mapStateToProps(state) {
    return {
        user: state.mainReducer.user,
        codpmpol: state.mainReducer.codpmpol,
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators(actionCreators, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);